import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal,  message } from 'antd';
import List from './components/List';
import Filter from './components/Filter';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import AddBa from './components/AddBa';
import DistributeGroupLeader from './components/DistributeGroupLeader'
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';

class BaGrouping extends Component {
    constructor(props) {
        super(props);
        const { params: { customerCompanyName, customerCompanyId } = {} } = props;
        const searchParams = {};
        if (customerCompanyName && customerCompanyId) {
            searchParams.customerCompanyId = customerCompanyId;
            searchParams.customerCompany = { text: customerCompanyName, value: customerCompanyId };
        }
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            hasAuth: false,       // 分配组长、删除权限
        };
    }

    componentDidMount() {
        this.queryAuth();
        this.loadData();
    }

    componentWillUnmount() {
        this.props.saveParams({
            customerCompanyId: undefined,
            customerCompanyName: undefined,
        });
    }

    queryAuth = () => {
        const { userId } = sessionStorage;
        Fetch.post(API_URL.contract.queryBaGroupUser).then(res => {
            const { data } = res;
            const hasAuth = (data || []).some(i => i == userId);
            this.setState({ hasAuth });
        }).catch(err => {
            console.error(err);
        });
    }

    loadData = () => {
        const { searchParams, pagination, sortParams } = this.state;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryBaList, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    delete = (record) => {
        const { userDetailId } = record;
        Modal.confirm({
			title: '确定要删除吗？',
            onOk: () => {
                this.setState({ loading: true });
				Fetch.post(API_URL.contract.deleteBA, {
                    userDetailId,
                }).then(res => {
                    message.success('删除成功');
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(err => {
                    console.error(err);
                    this.setState({ loading: false });
                });
            }
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const url = API_URL.contract.exportBa;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    confirmDirectly = record => {
        Modal.confirm({
            iconType: 'exclamation-circle',
			title: <div style={{ marginLeft: 42 }}>确认此项目在该月的未确认工时无需继续确认？</div>,
			content: '标记为无需继续确认，那么该月的未确认工时项目清单中，不再显示此项目',
            onOk: () => {
                const { hourId, hourType } = record;
				Fetch.post(API_URL.execute.comfirmUserFteMonthOne, {
                    hourId,
                    hourType,
                }).then(() => {
                    message.success('确认成功');
                    this.loadData();
                }).catch(err => {
                    console.error(err);
                });
            }
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleSearchChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    addBa = () => {
        this.baRef.show();
    }

    distributeGroupLeader = (record) => {
        this.groupLeaderRef.show(record);
    }

    render() {
        const { data, loading, pagination, sortParams, searchParams, hasAuth } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="baGrouping" />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            add={this.addBa}
                            hasAuth={hasAuth}
                            search={this.search}
                            export={this.export}
                            searchParams={searchParams}
                            onChange={this.handleSearchChange}
                        />
                        <List
                            data={data}
                            hasAuth={hasAuth}
                            loading={loading}
                            pagination={pagination}
                            sortParams={sortParams}
                            onChange={this.handleTableChange}
                            delete={this.delete}
                            distributeGroupLeader={this.distributeGroupLeader}
                        />
                        <DistributeGroupLeader
                            ref={el => this.groupLeaderRef = el}
                            loadData={this.loadData}
                        />
                        <AddBa
                            ref={el => this.baRef = el}
                            loadData={this.loadData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BaGrouping);


// WEBPACK FOOTER //
// ./src/components/contractManagement/baGrouping/index.js